import { logMessage } from "./amplifyLogger";
import { clientLog } from "../services/logging";

const MAX_LENGTH: number = Number(
  process.env.REACT_APP_COLUMN_LENGTH_BEFORE_ELLIPSIS ?? 25,
);

export const ellipse = (
  value: string | null | undefined,
  maxLength: number = MAX_LENGTH,
): string | null | undefined => {
  try {
    if (value && maxLength && value.length > maxLength) {
      value = `${value.substring(0, maxLength - 3)}...`;
    }
  } catch (err) {
    clientLog({
      component: `stringUtil`,
      message: `Unable to ellipse [${value}]. Error: ${err}`,
    });
    logMessage(
      "stringUtil",
      `Unable to ellipse [${value}]. Error: ${err}`,
      "error",
    );
  }
  return value;
};

export const getTitleForEllipse = (
  value: string | null | undefined,
): string => {
  if (value && value.length > MAX_LENGTH) {
    return value;
  } else {
    return "";
  }
};

export const isEmptyString = (value: unknown): boolean => {
  return typeof value === "string" && value.trim() === "";
};

export const isNotEmptyString = (value: unknown): boolean => {
  return typeof value === "string" && value.trim().length > 0;
};

/**
 * Capitalizes first letters of words in string.
 * @param {string} str String to be modified
 * @param {boolean=false} lower Whether all other letters should be lowercased
 * @return {string}
 * @usage
 *   capitalize('fix this string');     // -> 'Fix This String'
 *   capitalize('javaSCrIPT');          // -> 'JavaSCrIPT'
 *   capitalize('javaSCrIPT', true);    // -> 'Javascript'
 */
export const capitalize = (str: string, lower: boolean = false): string =>
  (lower ? str.toLowerCase() : str).replace(/(?:^|\s|["'([{])+\S/g, (match) =>
    match.toUpperCase(),
  );
